import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@drone-js/core';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { KeyItem } from 'component/page/detail/DetailCard/KeyInfos/KeyItem';
import { ItineraryStepperComponent } from 'component/page/detail/Itineraries/StructuredItinerary/ItineraryStepper';
import { mapStructuredItineraryToProps } from 'component/page/detail/Itineraries/StructuredItinerary/StructuredItinerary.selectors';
import { selectActivityContentLocale, selectActivityItinerary, selectActivityLocations } from 'component/page/detail/store/detail.selectors';
import ItineraryMultiDayComponent from 'component/page/detail/Itineraries/StructuredItinerary/ItineraryMultiDayCard';
import getDurationText from 'core/utils/getDurationText';
import { KeyInfoType } from 'component/page/detail/DetailCard/KeyInfos/KeyInfo.types';

const StructuredItinerary: React.FC = React.memo(() => {
    const cms = useSelector(selectCmsFromBootstrap);
    const itinerary = useSelector(selectActivityItinerary);
    const location = useSelector(selectActivityLocations);
    const contentLocale = useSelector(selectActivityContentLocale);

    if (!itinerary) {
        return null;
    }

    const itineraryList = mapStructuredItineraryToProps(itinerary, cms, location);
    if (itineraryList.length === 0) {
        return null;
    }

    const firstItinerary = itineraryList[0];
    const itineraryDuration = itinerary && itinerary.duration && itinerary.duration.minutes ? `${cms[130820]} ${getDurationText(itinerary.duration, cms)}` : '';

    return (
        <Box data-testid="detail-itinerary-wte" py="12">
            <Typography data-testid="detail-itinerary" variant="body-s-strong" tag="h3">
                {cms[130769]}
            </Typography>
            {itineraryDuration && <KeyItem key="duration" type={KeyInfoType.duration} text={itineraryDuration} iconId="line.symbol.time" />}
            {itineraryList.length > 1 ? (
                <ItineraryMultiDayComponent itineraryList={itineraryList} contentLocale={contentLocale} />
            ) : (
                <ItineraryStepperComponent dayItinerary={firstItinerary.days} dayDescription={firstItinerary.description} contentLocale={contentLocale} />
            )}
        </Box>
    );
});
StructuredItinerary.displayName = 'StructuredItinerary';

export default StructuredItinerary;
